import { ROUTES } from "../../../api/api.routes";
import useCustomQuery from "../../../hooks/useQuery";
import { Doc, ModelPrice, Sorted } from "../../../types";

export const useModelPrices = () => {
  const {
    data,
    isLoading,
    mutate,
    ...rest
  } = useCustomQuery<Sorted<Doc<ModelPrice>>>(ROUTES.ModelPrices.All.route);

  return {
    modelPrices: data?.items ?? [],
    modelPricesById: data?.byId ?? {},
    loadingModelPrices: isLoading,
    reloadModelPrices: mutate,
    ...rest
  }
}
